import React, { FC } from 'react';
import classNames from 'classnames';
import { ProductMetaData } from '../../../models/Product';
import { Article } from '../../../models/Article';
import { ProductSelection } from '../product-selection/ProductSelectionTypes';
import { hasProductSelection, isSelected, ProductIdOrOptions } from '../product-selection/ProductSelectionUtils';

export type SelectButtonProps = {
    productOrId: string | (ProductMetaData & Article);
    productSelection?: ProductSelection;
    onClick?: (props: ProductIdOrOptions) => void;
    isProductSelectable: boolean;
};

export const SelectButton: FC<SelectButtonProps> = ({
    productOrId,
    productSelection,
    onClick,
    isProductSelectable
}) => {
    if (!isProductSelectable) {
        return null;
    }

    const somethingSelected = hasProductSelection(productSelection);
    const selected = isSelected(productOrId, productSelection);
    const classes = classNames('icn-select', {
        selected,
        'selection-mode': somethingSelected
    });
    const title = `${selected ? 'de' : ''}select product`;

    return (
        <i
            data-testid="select-button"
            className={classes}
            title={title}
            onClick={() => {
                onClick?.(productOrId);
            }}
        />
    );
};

export default SelectButton;
